import WorkOrderEdit from './edit.vue'
import WorkOrderList from './list.vue'
import WorkOrderInfo from './info.vue'
import WorkOrderAllList from './allList.vue'
import deviceWorkOrderList from './devicelist.vue'
import WorkPending from './WorkPending.vue'
import * as OrderCompleted from './completed'
import * as OrderProcessing from './processing'
import * as workRecycleList from './recyclelist'
import * as workSeize from './seize'
import * as WorkOrderRepair from './repair.vue'
import * as WorkOrderTrack from './track.vue'
import * as WorkOrderEvaluate from './evaluate.vue'
import * as WorkOrderChange from './change.vue'
import * as WorkOrdertype from './worktype'
import * as WorkOrderChanges from './question.vue'
import * as WorkOrderEditPro from './editProcessing.vue'
import * as WorkOrderexpenseAccount from './expenseAccount.vue'





let a = Object.assign({ WorkOrderAllList,WorkOrderEdit, WorkOrderList, deviceWorkOrderList, WorkOrderInfo, WorkPending, WorkOrderRepair, WorkOrderTrack, WorkOrderEvaluate, WorkOrderChange, WorkOrderChanges, WorkOrderEditPro, WorkOrderexpenseAccount }, workRecycleList, OrderCompleted, OrderProcessing, WorkOrdertype, workSeize)
export default a
